'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LinkedClipboard = function LinkedClipboard(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M20.5,3h-4.2c-0.4-1.2-1.5-2-2.8-2s-2.4,0.8-2.8,2H6.5c-1.1,0-2,0.9-2,2v4.9c0.2,0,0.3,0,0.5,0h1.5V5h2v3h10V5h2v16h-14v0H5\nc-0.2,0-0.3,0-0.5,0v0c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C22.5,3.9,21.6,3,20.5,3z M13.5,5c-0.5,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1\nS14.1,5,13.5,5z"
  }), React__default["default"].createElement("path", {
    d: "M2.8,15.4c0-1.2,1-2.2,2.2-2.2h2.9v-1.4H5c-2,0-3.6,1.6-3.6,3.6S3.1,19,5,19h2.9v-1.4H5C3.8,17.6,2.8,16.6,2.8,15.4z\n M5.8,16.1h5.7v-1.4H5.8V16.1z M12.2,11.8H9.3v1.4h2.9c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2H9.3V19h2.9c2,0,3.6-1.6,3.6-3.6\nS14.2,11.8,12.2,11.8z"
  }));
};

var LinkedClipboard$1 = iconStyles()(LinkedClipboard);

module.exports = LinkedClipboard$1;
